import formatDatabaseDate from "~/utils/formatDatabaseDate";
import formatDatabaseDateOnly from "~/utils/formatDatabaseDateOnly";
import moment from 'moment';

export function ordinal_suffix_of(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

export const getOrdinalNumber = (number) => {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const remainder = number % 100;
    const suffix = suffixes[(remainder - 20) % 10] || suffixes[remainder] || suffixes[0];
    return `${number}${suffix}`;
};
export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.mixin({
        methods: {
            f_currency(value, code = 'GBP') {
                const codes = {
                    'GBP': '£',
                    'USD': '$',
                    // Add more currencies as needed
                };
                if (value === undefined || value === null) return '';
                const amount = parseFloat(value);
                return `${codes[code]}${amount.toFixed(2)}`;
            },
            f_ordinal_suffix(value) {
                return `${ordinal_suffix_of(value)}`;
            },
            f_prettyBytes(num){
                // jacked from: https://github.com/sindresorhus/pretty-bytes
                if (typeof num !== 'number' || isNaN(num)) {
                    throw new TypeError('Expected a number');
                }

                var exponent;
                var unit;
                var neg = num < 0;
                var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                if (neg) {
                    num = -num;
                }

                if (num < 1) {
                    return (neg ? '-' : '') + num + ' B';
                }

                exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
                num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
                unit = units[exponent];

                return (neg ? '-' : '') + num + ' ' + unit;
            },
            f_timestampDate(value){
                if (!value) return '';
                return formatDatabaseDate(value);
            },
            f_timestampDateOnly(value){
                if (!value) return '';
                return formatDatabaseDateOnly(value);
            },
            f_toTime(value){
                const sec_num = parseInt(value, 10); // don't forget the second param
                let hours   = Math.floor(sec_num / 3600);
                let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                let seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours   < 10) {hours   = "0"+hours;}
                if (minutes < 10) {minutes = "0"+minutes;}
                if (seconds < 10) {seconds = "0"+seconds;}
                return minutes+':'+seconds;
            },
            f_unixDateToTimestamp(value){
                return moment.unix(value).format('DD/MM/YYYY HH:mm');

            }
        }
    });
});
